import { ReactNode } from "react";

export interface ButtonProps {
  text?: string;
  type?: "button" | "submit" | "reset";
  children?: ReactNode;
  className?: string;
  id?: string;
  onClick?: () => void;
  dataToggle?: string;
  dataPlacement?: string;
  title?: string;
  disabled?: boolean;
}

export default function Button({
  text,
  type,
  onClick,
  children,
  className = "",
  id = "",
  dataToggle,
  dataPlacement,
  title,
  disabled,
}: ButtonProps) {
  return (
    <button
      id={id}
      className={`btn ${className}`}
      type={type ?? "button"}
      onClick={onClick}
      title={title}
      data-toggle={dataToggle}
      data-placement={dataPlacement}
      disabled={disabled}
    >
      {children}
      {text}
    </button>
  );
}
